import { redirect } from 'react-router-dom';
import { BaseLoader } from '@/utils/rtk/base.loader';
import { clientsApi } from '../clients/clientsApi';
import { dealsApi } from './dealsApi';
import { getDealClientId } from './helper';

export class DealLoader extends BaseLoader {
	detailLoader = async ({ params, request }) => {
		const dealRow = await this._loader(dealsApi.endpoints.getDealRow, request, params.dealId);

		// A numeric id is a HubSpot id from an old link; send it to the doc-id URL.
		if (dealRow?.id && /^\d+$/.test(params.dealId)) {
			const url = new URL(request.url);
			const pathname = url.pathname
				.split('/')
				.map((segment) => (segment === params.dealId ? dealRow.id : segment))
				.join('/');
			return redirect(`${pathname}${url.search}`);
		}

		const clientId = getDealClientId(dealRow);
		const client = clientId
			? await this._loader(clientsApi.endpoints.getClientProperties, request, clientId)
			: null;

		return { dealRow, client };
	};
}
